class FirstAidController {
    // @ngInject
    constructor($scope, $rootScope, localStorageService, $state, $stateParams, MEDICALCONSTANT, authService) {

        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }
        let schoolId = localStorageService.get('school_id')
        let userId = localStorageService.get('user_id')
        let patientid = ""
        $scope.selectedUsers = localStorageService.get('selectedUsers')
        authService.callAPI(MEDICALCONSTANT.API_GET_MEDICINE_LIST + schoolId, "GET", {}, (response) => {
            if (response.result && response.result.data && response.result.data.data) {
                if (response.result.data.data.length > 0)
                    $scope.medicineList = response.result.data.data
                _.defer(function() {
                    $scope.$apply();
                });
            }
        })
        $scope.selectedMedicine = (medicineName) => {
            $scope.batchIds = []
            _.each($scope.medicineList, function(eachPdt) {
                if (eachPdt.medicine_name === medicineName) {
                    $scope.batchIds.push({
                        'batch_no': eachPdt.batch_no,
                        'exp_date': eachPdt.exp_date
                    })

                }
            })
            $scope.batchIds.sort(function(a, b) {
                var nameA = a.exp_date
                var nameB = b.exp_date
                if (nameA < nameB) {
                    return -1;
                }
                if (nameA > nameB) {
                    return 1;
                }
                return 0;
            });
        }
        $scope.expDateError = null
        $scope.selectedBatchId = (batchId) => {
            if ($scope.batchIds[0].batch_no !== batchId)
                $scope.expDateError = "Please select first batchId in the list having least expiry date"
            else
                $scope.expDateError = null

            $scope.quantity = []
            _.each($scope.medicineList, function(eachPdt) {
                if (eachPdt.batch_no === batchId) {
                    if (eachPdt.remaining_count > 0) {

                        for (var i = 1; i <= eachPdt.remaining_count; i++) {
                            $scope.quantity.push(i);
                        }
                    }
                }

            })
        }


        $scope.firstAid = {}
        if ($stateParams.userId !== true && $stateParams.is_edit === true && $stateParams.data !== true) {
            if ($stateParams.is_edit) {
                $scope.isEdit = true
            }
            $scope.firstAid.complaint = $stateParams.data.complaint
            $scope.firstAid.treatement = $stateParams.data.treatment_given
            $scope.firstAid.remarks = $stateParams.data.remarks

        }

        $scope.saveFirstAid = () => {
            $scope.errors = {}
            let errCount = 0
            let obj = {
                    complaint: ($scope.firstAid.complaint) ? $scope.firstAid.complaint : null,
                    treatement: ($scope.firstAid.treatement) ? $scope.firstAid.treatement : null,
                    remarks: ($scope.firstAid.remarks) ? $scope.firstAid.remarks : null,
                    medicine: ($scope.firstAid.medicine) ? $scope.firstAid.medicine : null,
                    quantity: ($scope.firstAid.quantity) ? $scope.firstAid.quantity : null,
                    batch_id: ($scope.firstAid.batch_id) ? $scope.firstAid.batch_id : null,
                    follow_up: ($scope.firstAid.follow_up) ? $scope.firstAid.follow_up : null,
                    selected_users:$scope.selectedUsers,
                    user_id:userId
                }
            if (errCount > 0) {
                console.log("***")
            } else {
                if ($stateParams.is_edit === true && $stateParams.data !== true) {
                    /*Meteor.call("editFirstAid", obj, $scope.selectUser, $stateParams.data._id, function(error, result) {
                        if (error) {
                            toastr.error(error.reason)
                        } else {
                            $scope.errors = {}
                            ToastService.getToastbox($mdToast, "Successfully edited", 'warn-toast');
                            $state.go("medicalProfile", {
                                userId: $scope.selectUser
                            })
                        }
                    })*/

                } else {
                    if ($scope.expDateError === null) {
                        authService.callAPI(MEDICALCONSTANT.API_SAVE_FIRST_AID , "POST", obj, (response) => {
                            if (response.result && response.result.data && response.result.data.data) {
                                $state.go("userProfile")
                            }
                        })
                    }
                }
            }
        }




    }
}

export default FirstAidController



// WEBPACK FOOTER //
// ./src/app/medical/controllers/incidents/createFirstAidForm.js